import React, { FC } from 'react';

interface OwnProps {
  id?: string;
  key?: string;
  onClick?: () => void | null;
}

export const CloseIcon: FC<OwnProps> = ({ id, key, onClick }) => {
  return (
    <svg
      id={id}
      key={key}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
    >
      <g clipPath="url(#clip0_656_47863)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0577 3.94221C15.8015 3.68593 15.386 3.68593 15.1297 3.94221L9.99997 9.07191L4.87029 3.94223C4.61401 3.68595 4.19849 3.68595 3.94221 3.94223C3.68593 4.19851 3.68593 4.61403 3.94221 4.87031L9.07189 9.99999L3.94225 15.1296C3.68597 15.3859 3.68597 15.8014 3.94225 16.0577C4.19853 16.314 4.61405 16.314 4.87033 16.0577L9.99997 10.9281L15.1296 16.0577C15.3859 16.314 15.8014 16.314 16.0577 16.0577C16.314 15.8014 16.314 15.3859 16.0577 15.1297L10.928 9.99999L16.0577 4.87029C16.314 4.61401 16.314 4.19849 16.0577 3.94221Z"
          fill="#1A1A1A"
        />
      </g>
      <defs>
        <clipPath id="clip0_656_47863">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
